/* eslint-disable no-nested-ternary */

import axios from 'axios';
import { createInstance, headers, commonPyConfig, kebabcaseRequest } from '@cordata/buffet';

const deactivateIt = (i, url, config) => i.put(`${url}/activation`, { is_active: false }, config);
const activateIt = (i, url, config) => i.put(`${url}/activation`, { is_active: true }, config);

const common = {
  ...commonPyConfig,
  baseURL: process.env.REACT_APP_HOST_NAME,
  isAuthed: true,
  api: 'p',
  transformRequest: [
    kebabcaseRequest,
    ...axios.defaults.transformRequest,
  ],
};
const commonRb = {
  baseURL: `${process.env.REACT_APP_RB_HOST_NAME}/api`,
  headers,
  isAuthed: true,
  api: 'r',
  // transformResponse: [
  //   camelcaseResponse,
  //   ...axios.defaults.transformResponse,
  // ],
  // transformRequest: [
  //   kebabcaseRequest,
  //   ...axios.defaults.transformRequest,
  // ],
};

const baseInstance = createInstance({
  baseURL: process.env.REACT_APP_HOST_NAME,
});

const sessionInstance = createInstance(common);

const authorizedInstance = createInstance({
  ...common,
});

const authorizedRbInstance = createInstance({
  ...commonRb,
});

const sitInstance = createInstance({
  baseURL: `${process.env.REACT_APP_SIT_HOST_NAME}/kickstarter`,
  headers,
  isAuthed: true,
  api: 'sit',
});

const adminInstance = createInstance({
  ...common,
  baseURL: `${process.env.REACT_APP_HOST_NAME}/api/admin`,
});

const adminInstanceRaw = createInstance({
  baseURL: `${process.env.REACT_APP_HOST_NAME}/api/admin`,
  headers,
  isAuthed: true,
  api: 'none',
});

const referenceAdminInstance = createInstance({
  ...common,
  baseURL: `${process.env.REACT_APP_HOST_NAME}/api/reference-admin`,
});

const referenceInstance = createInstance({
  ...common,
  baseURL: `${process.env.REACT_APP_HOST_NAME}/api/data/reference`,
});

const publicInstance = createInstance({
  ...common,
  baseURL: `${process.env.REACT_APP_HOST_NAME}/api/data/public`,
});

const authorizedInstanceNoBase = createInstance({
  ...common,
});

authorizedInstance.deactivate = (url, config) =>
  deactivateIt(authorizedInstance, url, config);
authorizedInstance.activate = (url, config) =>
  activateIt(authorizedInstance, url, config);

referenceAdminInstance.deactivate = (url, config) =>
  deactivateIt(referenceAdminInstance, url, config);
referenceAdminInstance.activate = (url, config) =>
  activateIt(referenceAdminInstance, url, config);

export {
  sessionInstance,
  baseInstance,
  authorizedInstance,
  authorizedInstanceNoBase,
  adminInstance,
  adminInstanceRaw,
  referenceAdminInstance,
  referenceInstance,
  publicInstance,
  authorizedRbInstance,
  sitInstance,
};
